import { useAuth0 } from "@auth0/auth0-react";

export const useLogout = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Remove tokens from local storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("idToken");

    // Call Auth0 logout
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return { handleLogout };
};
